export default __webpack_public_path__ + "static/media/commission.6418dae7.png";